import * as React from 'react';
import { css, type RuleSet, styled } from 'styled-components';

import { tk, Typography } from '@sunwebgroup/ui-components';

import { useIntl } from '@/intl';

const Wrapper = styled.span<{ $disabled: boolean }>`
  display: block;
  margin-bottom: ${tk('spacing_sm')};

  ${Typography}:first-child {
    color: ${tk('color_semantic_text_strong')};
  }

  ${Typography}:last-child {
    color: ${tk('color_semantic_text')};
    white-space: nowrap;
  }

  ${({ $disabled }) => $disabled && modDisabled()}
`;
const modDisabled = (): RuleSet<object> => css`
  ${Typography}:first-child,
  ${Typography}:last-child {
    color: ${tk('color_semantic_bg_primary_disabled')};
  }
`;

export function RangeLabel({ disabled, formattedRange }: { disabled: boolean; formattedRange: string }) {
  const intl = useIntl();

  return (
    <Wrapper $disabled={disabled}>
      <Typography $variant="body-sm">{intl.formatMessage({ id: 'price_range_description' })}</Typography>{' '}
      <Typography $variant="body-md-bold">{formattedRange}</Typography>
    </Wrapper>
  );
}
